import React from 'react';
import { t as uiText } from '../../../i18n';

/** 「メールが届かない場合」のヘルプ（モーダル・バナー・ロック画面で共通利用） */
const EmailHelp: React.FC = () => (
  <details className="ev-help">
    <summary>{uiText('If the email does not arrive')}</summary>
    <div className="ev-help-body">
      <p>{uiText('If you did not receive the confirmation email, please check the following:')}</p>
      <ul>
        <li>{uiText('The email address you registered is correct')}</li>
        <li>{uiText('The email was not sorted into your spam folder')}</li>
        <li>{uiText('Delivery is not simply delayed')}</li>
      </ul>
      <p>{uiText('If it still does not arrive, please resend the confirmation email.')}</p>
      <p>{uiText('If the email address is wrong, you can change it.')}</p>
    </div>
  </details>
);

export default EmailHelp;
